import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { SocialType } from 'shared/models/User'
import { getAgentActivosBlackLink } from 'shared/utils/agentSocialLinks'

import { selectAgentSocialLinks } from 'features/auth/selectors'

export const useGetAgentLinks = () => {
  const links = useSelector(selectAgentSocialLinks, shallowEqual)

  return useMemo(() => {
    const byType = (type: SocialType) => links.find(item => item.socialType === type && Boolean(item.link))

    return {
      whatsapp: byType(SocialType.Whatsapp),
      telegram: byType(SocialType.Telegram),
      activosBlackLink: getAgentActivosBlackLink(links),
    }
  }, [links])
}
